import * as React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import useStyles from 'hooks/useStyles';
import { CardView, rem } from 'design-system';
import createStyleSheets from 'utils/createStyleSheets';
import { TAB_SCREEN_HEADER_HEIGHT } from 'navigators/styles';
import SecclInitialScreenTopInfo from 'features/invest/components/SecclInitialScreenTopInfo';
const WalkthroughInvestTabItem = ({ height, y, }) => {
    const styles = useStyles(styleSet);
    const { top } = useSafeAreaInsets();
    return (<>
      <View style={{ height: TAB_SCREEN_HEADER_HEIGHT + top + (y || 0) }}/>
      <CardView noMargin pointerEvents="none" style={styles.container}>
        <View style={{ height, justifyContent: 'center' }}>
          <SecclInitialScreenTopInfo />
        </View>
      </CardView>
    </>);
};
export default React.memo(WalkthroughInvestTabItem);
const styleSet = createStyleSheets((colors) => ({
    container: {
        borderRadius: rem(16),
        marginHorizontal: rem(12),
        backgroundColor: colors.background.dark,
    },
}));
